<script lang="ts" setup>
import type { DetailsHeadingVariant } from '@autobid/ui/types/components/CarDetails'

interface Props {
  variant?: DetailsHeadingVariant
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
})

const VARIANTS: Record<DetailsHeadingVariant, string> = {
  primary: 'bg-[#EAE7E0] text-primary text-base leading-7 md:text-xl',
  secondary: 'bg-[#E6E6E6] text-[15px]',
}
</script>

<template>
  <header :class="`px-4 py-2 font-bold uppercase ${VARIANTS[variant]}`">
    <slot />
  </header>
</template>
